// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"sP","sortWrapper":"tP","shortCount":"uP","fullCount":"vP","countWrapper":"wP","hasSavedSearch":"xP","desktopSaveSearch":"yP"};